import {createAsyncThunk} from "@reduxjs/toolkit";
import type {EventsHomePageMetaBackendResponse} from "@Components/mystuff-events-home/mystuff-events-home.types";

export const getEventsScheduleInfoForUser = createAsyncThunk<EventsHomePageMetaBackendResponse>('getEventsScheduleInfoForUser', () => {
    return window.PMW.readLocal('event/getEventsScheduleInfoForUser');
});